export default "/institutions/banestes.svg";